import { ICON_DETAIL_PAGE } from "data/links";

export const getFormattedData = ({
    slugWithId,
    hasPrepaidBalance,
    totalPrepaidBalanceAvailableCents
}) => {
    const submitText = "Use Prepaid Balance";
    const cancelText = "Get Basic Icon";
    const iconDetailLink = ICON_DETAIL_PAGE.replace(":slugWithId", slugWithId);

    if (!hasPrepaidBalance) {
        return {
            currentPrepaidBalance: 0,
            individualPrice: 0,
            availableIcons: 0,
            balanceAfterPurchase: 0,
            submitText,
            cancelText,
            iconDetailLink
        };
    }

    const currentPrepaidBalance = (
        totalPrepaidBalanceAvailableCents / 100
    ).toFixed(2);

    const individualPrice = (
        window._nounConfig.singleIconPriceCents / 100
    ).toFixed(2);

    const availableIcons = Math.round(currentPrepaidBalance / individualPrice);

    const balanceAfterPurchase = (
        currentPrepaidBalance - individualPrice
    ).toFixed(2);

    return {
        currentPrepaidBalance,
        individualPrice,
        availableIcons,
        balanceAfterPurchase,
        submitText,
        cancelText,
        iconDetailLink
    };
};

export const handleSubmit = e => {
    e.preventDefault();
    //todo: hook up functionality
};

export const weDontNeedThisFunc = e => {
    e.preventDefault();
    //todo: refactor button compnent so props dont scream when we dont pass this function
};
